import { useSiteContent } from '../../../hooks/useSiteContent';

export default function HeroSection() {
  const { content, loading } = useSiteContent();

  if (loading || !content) {
    return (
      <section id="home" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 to-purple-700">
        <div className="text-center text-white">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-white mx-auto"></div>
        </div>
      </section>
    );
  }

  const { hero } = content;

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {hero.background_image ? (
        <>
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${hero.background_image})` }}
          ></div>
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-purple-900/90"></div>
        </>
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-purple-700"></div>
      )}

      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-1/2 -right-1/2 w-full h-full bg-blue-500 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute -bottom-1/2 -left-1/2 w-full h-full bg-purple-500 rounded-full opacity-20 blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          {hero.title}
        </h1>
        <p className="text-xl md:text-2xl text-gray-100 mb-8 max-w-3xl mx-auto">
          {hero.subtitle}
        </p>
        <a
          href={hero.cta_link}
          className="inline-block px-8 py-4 bg-white text-blue-600 font-semibold rounded-full hover:bg-gray-100 transition-all transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
        >
          {hero.cta_text}
          <i className="ri-arrow-right-line ml-2 w-5 h-5 inline-flex items-center justify-center"></i>
        </a>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <i className="ri-trophy-line text-4xl text-yellow-400 mb-3 w-10 h-10 mx-auto flex items-center justify-center"></i>
            <div className="text-3xl font-bold text-white mb-2">10+</div>
            <div className="text-gray-200">Años de Experiencia</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <i className="ri-team-line text-4xl text-green-400 mb-3 w-10 h-10 mx-auto flex items-center justify-center"></i>
            <div className="text-3xl font-bold text-white mb-2">200+</div>
            <div className="text-gray-200">Clientes Satisfechos</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <i className="ri-star-line text-4xl text-blue-400 mb-3 w-10 h-10 mx-auto flex items-center justify-center"></i>
            <div className="text-3xl font-bold text-white mb-2">4.9/5</div>
            <div className="text-gray-200">Calificación Promedio</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#about" className="cursor-pointer">
          <i className="ri-arrow-down-line text-4xl text-white w-10 h-10 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}
